<template>
    <div class="vat-settings-loader">
        <div v-for="line in lines" :key="line" class="vat-settings-loader__line">
            <CompassSkeleton class="vat-settings-loader__label" />
            <CompassSkeleton class="vat-settings-loader__input" size="large" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        lines: {
            type: Number,
            default: 3,
        },
    },
};
</script>
<style lang="scss" scoped>
.vat-settings-loader {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    &__line {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);

        &:nth-child(2) {
            .vat-settings-loader__label {
                max-width: 180px;
            }
        }

        &:nth-child(3) {
            .vat-settings-loader__label {
                max-width: 140px;
            }
        }
    }

    &__label {
        max-width: 100px;
        width: 100%;
    }

    &__input {
        max-width: 220px;
        width: 100%;
    }
}
</style>
